"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isDayVisible;

var _moment = _interopRequireDefault(require("moment"));

var _isBeforeDay = _interopRequireDefault(require("./isBeforeDay"));

var _isAfterDay = _interopRequireDefault(require("./isAfterDay"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function isDayVisible(day, month, numberOfMonths, enableOutsideDays) {
  if (!_moment["default"].isMoment(day)) return false; // Cloning is a little expensive, so we want to do it as little as possible.
  // Here we clone the month once and keep mutating that moment object.

  var mutableMonth = month.clone();
  var firstDayOfFirstMonth = enableOutsideDays ? mutableMonth.startOf('month').startOf('week') : mutableMonth.startOf('month');
  if ((0, _isBeforeDay["default"])(day, firstDayOfFirstMonth)) return false;
  var lastDayOfLastMonth = enableOutsideDays // We need to call endOf('week') when enableOutsideDays is true, because we
  // are reusing the moment object, and our earlier mutation may have moved it
  // to a previous month. This should snap us back to a good starting place.
  ? mutableMonth.endOf('week').add(numberOfMonths - 1, 'months').endOf('month').endOf('week') : mutableMonth.add(numberOfMonths - 1, 'months').endOf('month');
  return !(0, _isAfterDay["default"])(day, lastDayOfLastMonth);
}